'use strict';

// The PDP owns selection and pricing. These answer sections read that same state.
let fitUnits = 'in';
function renderReferenceMeasurements() {
  const row = SIZE_CHART.find(item => item[0] === $('#reference-size').value);
  const factor = fitUnits === 'cm' ? 2.54 : 1;
  const measure = n => Number((n * factor).toFixed(1));
  $('#reference-measurements').innerHTML = `<div><dt>Body chest</dt><dd>${measure(row[1])}–${measure(row[2])} <small>${fitUnits}</small></dd></div><div><dt>Tee width, flat</dt><dd>${measure(row[3])} <small>${fitUnits}</small></dd></div><div><dt>Tee length</dt><dd>${measure(row[4])} <small>${fitUnits}</small></dd></div>`;
  $$('[data-fit-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fitUnit === fitUnits)));
}

function exploreColour(colour) {
  const key = photoKey(colour);
  const hasPhoto = Object.hasOwn(PHOTO_DATA, key);
  const img = $('#colour-explorer-image');
  const swatch = $('#colour-explorer-swatch');
  img.hidden = !hasPhoto;
  swatch.hidden = hasPhoto;
  if (hasPhoto) {
    img.src = window.EtPdp.config.assets[key];
    img.alt = PHOTO_DATA[key].alt;
  } else {
    swatch.querySelector('span').style.background = COLOURS[colour];
    swatch.querySelector('strong').textContent = colour;
  }
  $('#colour-explorer-caption').textContent = hasPhoto ? `${colour} · ${photoCaption(key)} Screens and lighting can affect colour.` : `${colour} · Swatch guide only. This does not change your bundle.`;
  $$('[data-explore-colour]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.exploreColour === colour)));
}

function renderAnswerPrices() {
  $('#receipt-heading').textContent = `${state.count} ${state.fabric} ${state.count === 1 ? 'tee' : 'tees'}`;
  $('#receipt-base-label').textContent = state.count === 1 ? '1 tee' : `${state.count}-tee bundle`;
  $('#receipt-base').textContent = money(basePrice(state.count));
  $('#receipt-upgrade-label').textContent = state.fabric === 'Premium' ? `Premium · ${state.count} × £2` : 'Standard fabric';
  $('#receipt-upgrade').textContent = state.fabric === 'Premium' ? money(state.count * upgrade()) : 'Included';
  $('#receipt-total').textContent = money(subtotal());
  $('#receipt-choice-summary').textContent = `${state.finish} finish. ${valid() ? 'Your sizes are selected.' : 'Choose a size for every tee before adding to bag.'}`;
  $('#fabric-upgrade-explained').textContent = `Premium adds ${money(state.count * 2)} to your ${state.count === 1 ? 'tee' : state.count + '-tee bundle'}. ${money(basePrice(state.count) + state.count * 2)} before delivery.`;
}

$('#colour-reference-buttons').innerHTML = Object.entries(COLOURS).map(([colour, hex]) => `<button type="button" data-explore-colour="${safe(colour)}" aria-pressed="${colour === 'Green'}"><span style="background:${hex}" aria-hidden="true"></span><span>${safe(colour)}</span></button>`).join('');
$('#reference-size').addEventListener('change', renderReferenceMeasurements);
document.addEventListener('pdp:selectionchange', renderAnswerPrices);
document.addEventListener('click', event => {
  const unit = event.target.closest('[data-fit-unit]');
  if (unit) { fitUnits = unit.dataset.fitUnit; renderReferenceMeasurements(); }
  const colour = event.target.closest('[data-explore-colour]');
  if (colour) exploreColour(colour.dataset.exploreColour);

});
renderReferenceMeasurements();
renderAnswerPrices();

